import { createIcon } from "@chakra-ui/react";

export const Silver = createIcon({
  displayName: "Fun",
  viewBox: "0 0 48 48",
  path: [
    <path
      d="M22.404 0H.484l11.71 11.759 14.42-7.518L22.403 0z"
      fill="#CF4655"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.51-.252H-.123l12.268 12.32 14.886-7.762L22.51-.252zm-.21.504 3.894 3.924L12.24 11.45 1.09.252H22.3z"
      fill="#2B2C3D"
    />,
    <path
      d="M14.517 10.988 25.646 0h21.87l-11.71 11.759-21.29-.771z"
      fill="#F16063"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.122-.252h-22.58l-11.617 11.47 21.982.796L48.123-.252zm-1.211.504L35.706 11.504l-20.598-.746L25.748.252h21.163z"
      fill="#2B2C3D"
    />,
    <path
      d="M3.87 27.952C3.87 39.024 12.884 48 24 48c11.117 0 20.129-8.976 20.129-20.048 0-11.073-9.012-20.048-20.13-20.048-11.116 0-20.128 8.975-20.128 20.048z"
      fill="#CBD5E0"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 47.497c-10.841 0-19.626-8.753-19.626-19.545C4.374 17.159 13.16 8.407 24 8.407c10.84 0 19.626 8.752 19.626 19.545 0 10.792-8.785 19.545-19.626 19.545zM24 48C12.883 48 3.87 39.024 3.87 27.952 3.87 16.879 12.884 7.904 24 7.904c11.117 0 20.129 8.975 20.129 20.048C44.129 39.024 35.117 48 23.999 48z"
      fill="#2B2C3D"
    />,
    <path
      d="M6.387 27.952c0 9.688 7.886 17.542 17.613 17.542 9.728 0 17.613-7.854 17.613-17.542 0-9.688-7.885-17.542-17.613-17.542-9.727 0-17.613 7.854-17.613 17.542z"
      fill="#EDF2F7"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 44.99c-9.45 0-17.11-7.63-17.11-17.038 0-9.409 7.66-17.04 17.11-17.04 9.452 0 17.11 7.631 17.11 17.04 0 9.408-7.658 17.039-17.11 17.039zm0 .504c-9.727 0-17.613-7.854-17.613-17.542 0-9.688 7.886-17.542 17.613-17.542 9.728 0 17.613 7.854 17.613 17.542 0 9.688-7.885 17.542-17.613 17.542z"
      fill="#2B2C3D"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.008 28.483a5.834 5.834 0 0 1 3.313-3.319 5.817 5.817 0 0 1-3.706-5.416v-.393h6.192V30.58c0 3.202-2.602 5.807-5.8 5.807-3.197 0-5.799-2.605-5.799-5.807v-5.809h.393a5.808 5.808 0 0 1 5.407 3.712zm-5.015-2.91v4.629a5.803 5.803 0 0 1 4.622 2.88V30.58a5.026 5.026 0 0 0-4.622-5.008zM24.4 30.58v2.495a5.84 5.84 0 0 1 .914-1.187 5.75 5.75 0 0 1 3.708-1.687v-4.629A5.026 5.026 0 0 0 24.4 30.58zm4.622-10.439h-4.607a5.027 5.027 0 0 0 4.607 4.615V20.14zm-.017 10.849a5.027 5.027 0 0 0-4.588 4.594 5.025 5.025 0 0 0 4.588-4.594zm-5.406 4.594a4.99 4.99 0 0 0-1.453-3.14 4.972 4.972 0 0 0-3.136-1.454 5.026 5.026 0 0 0 4.589 4.594z"
      fill="#CBD5E0"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.208 24.771v5.81c0 3.201 2.601 5.806 5.8 5.806 3.197 0 5.798-2.605 5.798-5.807V19.355h-6.191v.393a5.815 5.815 0 0 0 3.706 5.416 5.84 5.84 0 0 0-3.313 3.32 5.803 5.803 0 0 0-5.407-3.712l-.393-.001zm5.8 2.803a6.187 6.187 0 0 0-5.407-3.19h-.78v6.196c0 3.415 2.774 6.194 6.186 6.194s6.186-2.779 6.186-6.194V18.968h-6.965v.78a6.2 6.2 0 0 0 3.186 5.416 6.23 6.23 0 0 0-2.407 2.41zm-5.015-2.001a5.028 5.028 0 0 1 4.622 5.008v2.502a5.793 5.793 0 0 0-4.622-2.881v-4.63zm.387.437a4.642 4.642 0 0 1 3.848 4.57v1.31a6.175 6.175 0 0 0-3.848-2.04v-3.84zm5.407 5.873V30.58a4.642 4.642 0 0 1 3.847-4.57v3.84a6.136 6.136 0 0 0-3.847 2.033zM24.4 30.58a5.028 5.028 0 0 1 4.621-5.007V30.2a5.75 5.75 0 0 0-3.708 1.687 5.853 5.853 0 0 0-.913 1.187V30.58zm.452-10.051h3.782v3.79a4.645 4.645 0 0 1-3.782-3.79zm4.17-.388v4.615a5.031 5.031 0 0 1-4.606-4.614h4.605zm-.41 10.897c.13-.021.26-.037.393-.048a5.03 5.03 0 0 1-4.588 4.594 5.03 5.03 0 0 1 4.195-4.547zm-3.745 4.096a4.644 4.644 0 0 0 3.687-3.693 4.645 4.645 0 0 0-3.687 3.693zm-1.316.058c.02.13.037.26.047.392a5.03 5.03 0 0 1-4.589-4.595 4.973 4.973 0 0 1 3.137 1.455 4.99 4.99 0 0 1 1.405 2.748zm-.403-.058a4.645 4.645 0 0 1-3.688-3.694c.908.17 1.743.608 2.412 1.278a4.603 4.603 0 0 1 1.276 2.416z"
      fill="#2B2C3D"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.386 19.355v.786h-3.392v3.398h-.785v-4.184h4.177z"
      fill="#CBD5E0"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.773 18.968H17.82v4.958h1.56v-3.398h3.392v-1.56zm-.388 1.173v-.786h-4.177v4.184h.785v-3.398h3.392z"
      fill="#2B2C3D"
    />,
    <path
      d="m33.774 32.193-.059.772c-.054.71-.421 1.271-.887 1.354l-.506.09.506.09c.466.083.833.643.887 1.355l.059.773.059-.773c.054-.712.421-1.272.887-1.355l.505-.09-.505-.09c-.466-.083-.833-.643-.887-1.355l-.059-.772z"
      fill="#2B2C3D"
    />,
  ],
  defaultProps: {
    "aria-label": "A silver medal"
  }
});

export default Silver;
